import React from 'react';
import vet1 from '../../../icons/vet-1.svg';
import vet2 from '../../../icons/vet-2.svg';
import vet3 from '../../../icons/vet-3.svg';
import vet4 from '../../../icons/vet-4.svg';
import vet5 from '../../../icons/vet-5.svg';
import vet6 from '../../../icons/vet-6.svg';
import vet7 from '../../../icons/vet-7.svg';
import vet8 from '../../../icons/vet-8.svg';
import vet9 from '../../../icons/vet-9.svg';

const VET_ICONS = [vet1, vet2, vet3, vet4, vet5, vet6, vet7, vet8, vet9];

const VetIcon = ({ index, alt }) => (
    <img
        className="vetlab-step-icon"
        src={VET_ICONS[index]}
        alt={alt || `Шаг ${index + 1}`}
    />
);

export default VetIcon;
